import styled from "styled-components";

export const SearchBarRoot = styled.div`
  position: relative;
  width: 100%;
  max-width: ${(p) => p.$maxWidth ?? "600px"};
  margin-bottom: ${(p) => p.$marginBottom ?? "20px"};
  margin-top: ${(p) => p.$marginTop ?? "0"};

  label {
    display: block;
    position: relative;
    width: 100%;
  }

  input[type="search"] {
    font-size: 14px;
    font-weight: bold;
    background: #fff;
    line-height: 28px;
    padding: 10px 40px 10px 10px;
    border: solid thin #b3b3b3;
    width: 100%;
    box-sizing: border-box;
    :hover {
      border: solid thin #2251ff;
    }
    :focus {
      border: solid thin #2251ff;
      outline: none;
    }
    ::placeholder {
      color: #757575;
      font-weight: 300;
      font-size: 14px;
    }
    ::-webkit-search-cancel-button {
      display: none;
    }
    ::-ms-clear {
      display: none;
    }
  }

  .portal-search-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .portal-search-clear {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 4px;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }
`;
